import React, { useMemo } from 'react';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Trend360.json';
import inputTypeIntro from '../static/introspection/Trend360PatchInput.json';
import { ENTITY } from '../utils/entities';
import { Trend360PatchMutation } from 'graphql/mutations/Trend360PatchMutation';
import { Trend360DetailQuery } from 'graphql/query/Trend360DetailQuery';
import { graphqlQuery } from 'utils/graphql';
import {
	TREND360_EDIT_FIELDS,
	trend360EditHandlers,
} from 'utils/entities/trend360';

/**
 * Pagina di modifica di un Trend360.
 *
 * La tipologia del trend NON e' modificabile (decide quali campi esistono ed e' readonly
 * lato server): non essendo nota prima del caricamento, si passa come whitelist l'unione
 * dei campi di tutte le tipologie e ci pensa il transformer a tenere solo quelli della
 * tipologia del record.
 *
 * NB - si riusa la DetailQuery come fetcher: espone gia' il frammento completo (colonne
 * + i cinque campi di sola lettura degli slot keyed) e ogni lista di relazioni da una
 * radice aliasata propria, che il transformer riceve come terzo argomento.
 */
const Trend360Edit: React.FC<{ id: string }> = ({ id }) => {
	// transformer e handler di salvataggio condividono lo stato iniziale caricato:
	// devono essere la stessa istanza
	const handlers = useMemo(() => trend360EditHandlers(), [id]);

	return (
		<EntityEditFetcher
			// IMPORTANT - network-only: questi dati non sono solo mostrati, diventano la
			// base del confronto per capire quali relazioni aggiungere o togliere. Una
			// lettura dalla cache (che le mutation su Relationships360 non aggiornano)
			// produrrebbe un confronto contro relazioni non piu' esistenti.
			fetcher={graphqlQuery(
				Trend360DetailQuery,
				{ id },
				{ fetchPolicy: 'network-only' } as any,
			)}
			id={id}
			mutation={Trend360PatchMutation}
			typeIntro={typeIntro}
			inputTypeIntro={inputTypeIntro}
			entityName={ENTITY.TREND_360}
			fields={TREND360_EDIT_FIELDS as string[]}
			transformer={handlers.transformer}
			beforeSaveTransformer={handlers.beforeSaveTransformer}
			afterSave={handlers.afterSave}
		/>
	);
};

export { Trend360Edit };
